module.exports = __webpack_public_path__ + "static/media/room1.4b35e90f.png";